import { takeEvery, put, call } from 'redux-saga/effects';

import { coreAPI } from 'utils/request';
import { transferFolioBookingSuccess } from '../actions';
import { TRANSFER_FOLIO_BOOKING } from '../constants';
import { showErrorNotification } from '@aha/utils';

function* doTransferFolio({ bid, fid, folio, reject, resolve }) {
  try {
    const { data } = yield call(
      coreAPI.post,
      `v1/pms/bookings/${bid}/folios/${fid}/transfer`,
      folio,
    );
    yield put(transferFolioBookingSuccess(data));
    resolve(data);
  } catch (err) {
    showErrorNotification('Transfer booking folio failed', err);
    reject(err);
  }
}

export function* watchTransferFolio() {
  yield takeEvery(TRANSFER_FOLIO_BOOKING, doTransferFolio);
}
